import React from 'react'
import { List, Datagrid, TextField, BooleanField, ReferenceField, ImageField, EditButton, Responsive, SimpleList, DeleteButton } from 'react-admin'
import { ListActions, TableRowList } from '../../../components'
import { getResource } from '../../../config/resources'
import { withStyles } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'

const Actions = (props) => {
  return <ListActions {...props} />
}

const styles = (theme) => ({
  deleteStyle: {
    color: fade(theme.palette.error.main, 0.9),
    padding: '2px 6px 2px 2px',
  },
})

const ChatbotQuestionsList = (props) => {
  return (
    <List title="Chatbot Questions" bulkActions={false} {...props} actions={<Actions />}>
      <Responsive
        small={<SimpleList primaryText={(record) => record.question} />}
        medium={
          <Datagrid>
            <TextField source="question" />
            <TextField source="id" />
            <TableRowList>
              <EditButton />
              <DeleteButton className={props.classes.deleteStyle} />
            </TableRowList>
          </Datagrid>
        }
      />
    </List>
  )
}

export default withStyles(styles)(ChatbotQuestionsList)
